import { cn } from "@/lib/utils";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "default" | "outline" | "ghost";
  size?: "default" | "sm";
};

export function Button({ className, variant = "default", size = "default", ...props }: ButtonProps) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center rounded-md text-sm font-semibold transition disabled:opacity-50",
        size === "default" && "h-9 px-4",
        size === "sm" && "h-8 px-3 text-xs",
        variant === "default" && "bg-gray-900 text-white hover:bg-gray-800 dark:bg-white dark:text-gray-900",
        variant === "outline" && "border border-gray-300 bg-white hover:bg-gray-50 dark:border-white/20 dark:bg-transparent",
        variant === "ghost" && "bg-transparent hover:bg-gray-100 dark:hover:bg-white/10",
        className,
      )}
      {...props}
    />
  );
}
